import { i18n } from '@lingui/core';
import { IconFilter16 } from '@warp-ds/icons/react/filter-16';
import { Button } from '@warp-ds/react';
import React from 'react';

const buttonStyle: React.CSSProperties = {
    paddingLeft: '8px',
    paddingRight: '8px',
};

const animatedLabelStyle: React.CSSProperties = {
    overflowX: 'hidden',
    transition: 'width 250ms',
};

type FilterButtonProps = {
    collapsed: boolean;
    onClick?: () => void;
};

export function FilterButton(props: FilterButtonProps) {
    const { collapsed, onClick } = props;

    const buttonLabelRef = React.useRef<HTMLElement | null>(null);
    const buttonLabelWidth = React.useRef<number>();

    const initButtonLabelRef = React.useCallback(
        (element: HTMLElement | null) => {
            if (element) {
                buttonLabelRef.current = element;
                buttonLabelWidth.current = element.clientWidth;
            }
        },
        [],
    );

    React.useEffect(
        function animateButtonLabelWidth() {
            if (buttonLabelRef.current) {
                buttonLabelRef.current.style.width = collapsed
                    ? '0'
                    : `${buttonLabelWidth.current}px`;
            }
        },
        [collapsed, buttonLabelRef],
    );

    return (
        <Button
            className="flex items-center"
            onClick={onClick}
            small
            style={buttonStyle}
        >
            <IconFilter16 />
            <span ref={initButtonLabelRef} style={animatedLabelStyle}>
                <span className="ml-8">
                    {i18n.t({
                        id: 'filters.mobile.open',
                        message: 'Filter',
                    })}
                </span>
            </span>
        </Button>
    );
}
